import styled from 'styled-components';
import { Link } from 'react-router-dom';
import settings from '../data/settings.json';

const FooterWrapper = styled.footer`
  background: #2f2a26;
  color: #f7efe5;
  padding: 2.5rem 1.5rem 1.5rem;
  margin-top: auto;
`;

const Inner = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  gap: 2rem;
  grid-template-columns: 1.4fr 1fr 1fr;

  @media (max-width: 850px) {
    grid-template-columns: 1fr;
  }
`;

const Brand = styled.div`
  font-size: 1.35rem;
  font-weight: 700;
  color: #fff;
  margin-bottom: 0.5rem;
`;

const Text = styled.p`
  color: #d9cec2;
  line-height: 1.6;
  margin: 0.25rem 0;
`;

const Heading = styled.h3`
  color: #fff;
  font-size: 1rem;
  margin-bottom: 0.75rem;
`;

const FooterLink = styled(Link)`
  display: block;
  color: #d9cec2;
  text-decoration: none;
  margin-bottom: 0.45rem;

  &:hover {
    color: #fff;
  }
`;

const ExternalLink = styled.a`
  color: #d9cec2;
  text-decoration: none;

  &:hover {
    color: #fff;
  }
`;

const Bottom = styled.div`
  max-width: 1200px;
  margin: 2rem auto 0;
  padding-top: 1rem;
  border-top: 1px solid rgba(255,255,255,0.12);
  color: #c5b8ac;
  font-size: 0.9rem;
`;

function Footer() {
  return (
    <FooterWrapper>
      <Inner>
        <div>
          <Brand>{settings.name}</Brand>
          <Text>{settings.tagline}</Text>
          <Text>{settings.address}</Text>
        </div>

        <div>
          <Heading>Kontakt</Heading>
          <Text>
            <ExternalLink href={`tel:${settings.phone.replace(/\s/g, '')}`}>
              {settings.phone}
            </ExternalLink>
          </Text>
          <Text>
            <ExternalLink href={`mailto:${settings.email}`}>
              {settings.email}
            </ExternalLink>
          </Text>
        </div>

        <div>
          <Heading>Rechtliches</Heading>
          <FooterLink to="/impressum">Impressum</FooterLink>
          <FooterLink to="/datenschutz">Datenschutz</FooterLink>
        </div>
      </Inner>

      <Bottom>
        © {new Date().getFullYear()} {settings.name}. Alle Rechte vorbehalten.
      </Bottom>
    </FooterWrapper>
  );
}

export default Footer;